export enum ActionType {
  IDENTITY = "identity",
}

export interface AdmsAction<T = unknown> {
  time: number;
  name: string;
  type: ActionType;
  payload?: T;
}

export interface IdentityAction extends AdmsAction {
  type: ActionType.IDENTITY;
  payload: {
    identityType: string;
    identityToken: string;
  };
}

export interface ActiveData {
  IDENTITY?: IdentityAction[];
}
